import React, { createContext, useContext, useEffect } from 'react';
import type { ThemeMode } from './theme';

const STORAGE_KEY = 'admin_theme';

interface ThemeModeCtx {
  mode: ThemeMode;
  toggle: () => void;
}

const Ctx = createContext<ThemeModeCtx>({ mode: 'light', toggle: () => {} });

export function getInitialMode(): ThemeMode {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export const ThemeModeProvider: React.FC<{
  mode: ThemeMode;
  setMode: (m: ThemeMode) => void;
  children: React.ReactNode;
}> = ({ mode, setMode, children }) => {
  useEffect(() => {
    document.documentElement.dataset.theme = mode;
    localStorage.setItem(STORAGE_KEY, mode);
  }, [mode]);

  return (
    <Ctx.Provider value={{ mode, toggle: () => setMode(mode === 'light' ? 'dark' : 'light') }}>
      {children}
    </Ctx.Provider>
  );
};

export const useThemeMode = () => useContext(Ctx);
